import { render, staticRenderFns } from "./AssetSuggestions.vue?vue&type=template&id=422908e2&scoped=true"
import script from "./AssetSuggestions.vue?vue&type=script&lang=js"
export * from "./AssetSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422908e2",
  null
  
)

export default component.exports